(function() {
    'use strict';

    // Configuration
    const CONVO_CONFIG = {
        apiUrl: 'https://api.conversecart.com/search/shopify_search',
        visualApiUrl: 'https://api.conversecart.com/recommendations/visual/upload',
        indexID: '691665dfcf15ea6bf452b670',
        minQueryLength: 2,
        debounceDelay: 300,
        maxProducts: 40,
        maxSuggestions: 5,
        searchPageUrl: '/pages/search',

        animatedPlaceholder: {
            enabled: true,
            prefix: "Search for ",
            suffixes: [
                "Men's Costumes",
                "Women's Costumes",
                "Animated Halloween Props",
                "Halloween",
                "Wigs",
                "Boy's Costumes",
                "Girl's Costumes",
                "Masks"
            ],
            typeInterval: 100,
            typeTimeout: 1000,
            eraseInterval: 100,
            eraseTimeout: 3000
        }
    };

    // State
    let debounceTimer = null;
    let currentQuery = '';
    let autocompleteContainer = null;
    let isOpen = false;
    // Data URL of the image backing the current image search (if any).
    // Used to hand the image off to the search page on "View More".
    let currentImageDataUrl = null;

    let animationRunning = false;
    let animationTimeout = null;

    function stopAnimatedPlaceholder() {
        animationRunning = false;
        if (animationTimeout) {
            clearTimeout(animationTimeout);
            animationTimeout = null;
        }
    }

    function startAnimatedPlaceholder(input) {
        const config = CONVO_CONFIG.animatedPlaceholder;
        if (!config.enabled || !config.suffixes || config.suffixes.length === 0) {
            return;
        }

        stopAnimatedPlaceholder();
        animationRunning = true;

        const prefix = config.prefix || '';
        const suffixes = config.suffixes;
        let suffixIndex = 0;
        let currentText = '';

        input.setAttribute('placeholder', prefix);

        function scheduleNext(fn, delay) {
            animationTimeout = setTimeout(() => {
                if (animationRunning) {
                    fn();
                }
            }, delay);
        }

        function typeOneChar() {
            const targetSuffix = suffixes[suffixIndex];

            if (currentText.length < targetSuffix.length) {
                currentText = targetSuffix.substring(0, currentText.length + 1);
                input.setAttribute('placeholder', prefix + currentText);
                scheduleNext(typeOneChar, config.typeInterval);
            } else {
                scheduleNext(eraseOneChar, config.eraseTimeout);
            }
        }

        function eraseOneChar() {
            if (currentText.length > 0) {
                currentText = currentText.substring(0, currentText.length - 1);
                input.setAttribute('placeholder', prefix + currentText);
                scheduleNext(eraseOneChar, config.eraseInterval);
            } else {
                suffixIndex = (suffixIndex + 1) % suffixes.length;
                scheduleNext(typeOneChar, config.typeTimeout);
            }
        }

        scheduleNext(typeOneChar, config.typeInterval);
    }

    function pauseAnimatedPlaceholder(input) {
        stopAnimatedPlaceholder();
        if (input) {
            input.setAttribute('placeholder', '');
        }
    }

    function resumeAnimatedPlaceholder(input) {
        if (input && input.value.trim() === '') {
            startAnimatedPlaceholder(input);
        }
    }

    function getSessionID() {
        const exists = document.cookie.split(';').some((item) => item.trim().startsWith('ccsessionID='));
        if (localStorage.getItem('sessionID') && !exists) {
            document.cookie = "ccsessionID=" + localStorage.getItem('sessionID');
            document.cookie = "ccsessionKey=" + localStorage.getItem('sessionKey');
        }
        return localStorage.getItem('sessionID');
    }

    function formatPrice(price) {
        return new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD'
        }).format(price);
    }

    function getImageUrl(src, size) {
        if (!src) return '';
        return src.replace(/\.(jpg|jpeg|png|gif)\?v=/, `_${size}x.$1?v=`);
    }

    function createAutocompleteHTML() {
        return `
            <div class="convo-autocomplete-wrapper" id="convo-autocomplete" style="display: none;">
                <div class="convo-sugegstions-products-wrapper">
                    <div class="convo-autocomplete-suggestions" id="convo-suggestions" style="display: none;">
                        <p class="convo-suggestions-title">SUGGESTIONS</p>
                        <ul class="convo-suggestions-list" id="convo-suggestions-list"></ul>
                    </div>
                    <div class="convo-autocomplete-top-products" id="convo-products">
                        <p class="convo-top-products-title">TOP 10 SEARCH RESULTS</p>
                        <ul class="convo-autocomplete-top-products-list" id="convo-products-list"></ul>
                    </div>
                    <div class="convo-autocomplete-view-more" id="convo-footer" style="display: none;">
                        <button type="submit" class="btn convo-view-more-btn">View More</button>
                    </div>
                </div>
                <div class="convo-autocomplete-loading" id="convo-loading" style="display: none;">
                    <div class="convo-spinner"></div>
                </div>
                <div class="convo-autocomplete-no-results" id="convo-empty" style="display: none;">
                    <span class="no-results-message">Sorry, nothing found.</span>
                </div>
            </div>
        `;
    }

    function createProductCardHTML(product) {
        const featuredImage = product.images && product.images[0] ? product.images[0] : null;
        const imageSrc = featuredImage ? getImageUrl(featuredImage.src, 400) : '';
        const hoverImage = product.images && product.images[1] ? getImageUrl(product.images[1].src, 400) : imageSrc;
        const price = product.variants && product.variants[0] ? product.variants[0].price : 0;
        const comparePrice = product.variants && product.variants[0] ? product.variants[0].compare_at_price : null;
        const onSale = comparePrice && comparePrice > price;
        const productUrl = `/products/${product.handle}`;

        return `
            <li class="convo-topproduct-item" title="${product.title}" data-id="${product.id}">
                <a href="${productUrl}" class="convo-topproduct-item-link">
                    <div class="convo-topproduct-image-wrapper">
                        ${onSale ? `<div class="hc-sale-tag"><span>Sale</span></div>` : ''}
                        <div class="convo-topproduct-item-image">
                            ${imageSrc ? `<img src="${imageSrc}" class="convo-topproduct-image" loading="lazy" alt="${product.title}">` : ''}
                        </div>
                        <div class="convo-topproduct-item-image hover-image">
                            <img src="${hoverImage}" class="convo-topproduct-image" loading="lazy" alt="${product.title}">
                        </div>
                    </div>
                    <div class="convo-topproduct-item-info">
                        <p class="convo-topproduct-title">${product.title}</p>
                        <div class="convo-topproduct-price">
                            <div class="price ${onSale ? 'price--on-sale' : ''} flex flex-wrap gap-2 md:gap-1d5">
                                <span class="price__regular whitespace-nowrap">${formatPrice(price)}</span>
                                ${onSale ? `<span class="price__sale inline-flex items-center h-auto relative">${formatPrice(comparePrice)}</span>` : ''}
                            </div>
                        </div>
                    </div>
                </a>
            </li>
        `;
    }

    async function fetchShopifySuggestions(query) {
        try {
            const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=query&resources[limit]=5`;
            const response = await fetch(url);

            if (!response.ok) {
                return [];
            }

            const data = await response.json();
            if (data.resources && data.resources.results && data.resources.results.queries) {
                return data.resources.results.queries;
            }
            return [];
        } catch (error) {
            console.error('Shopify suggestions error:', error);
            return [];
        }
    }

    // -----------------------------------------------------------------
    // TEXT SEARCH: POST JSON to /search/shopify_search
    // -----------------------------------------------------------------
    async function fetchConvoProducts(query) {
        try {
            const sessionID = getSessionID();

            const requestBody = {
                sessionID: sessionID,
                indexID: CONVO_CONFIG.indexID,
                query: query || '',
                top_k: 30,
                loc: 1
            };

            const response = await fetch(CONVO_CONFIG.apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'Origin': window.location.origin,
                },
                body: JSON.stringify(requestBody)
            });

            if (!response.ok) {
                throw new Error('Search request failed');
            }

            return await response.json();
        } catch (error) {
            console.error('ConvoSearch autocomplete error:', error);
            return null;
        }
    }

    // -----------------------------------------------------------------
    // IMAGE / VISUAL SEARCH: POST multipart to /recommendations/visual/upload
    // -----------------------------------------------------------------
    async function fetchVisualSearch(file) {
        try {
            const formData = new FormData();
            formData.append('image', file);
            formData.append('indexID', CONVO_CONFIG.indexID);
            formData.append('top_k', String(CONVO_CONFIG.maxProducts));
            formData.append('shopify', 'true');

            const response = await fetch(CONVO_CONFIG.visualApiUrl, {
                method: 'POST',
                headers: {
                    'accept': 'application/json'
                },
                body: formData
            });

            if (!response.ok) {
                throw new Error('Visual search request failed: ' + response.status);
            }

            return await response.json();
        } catch (error) {
            console.error('ConvoSearch visual search error:', error);
            return null;
        }
    }

    async function fetchAutocomplete(query) {
        const [suggestions, products] = await Promise.all([
            fetchShopifySuggestions(query),
            fetchConvoProducts(query)
        ]);

        return {
            suggestions: suggestions,
            products: products
        };
    }

    async function fetchImageAutocomplete(file) {
        const products = await fetchVisualSearch(file);
        return {
            suggestions: [],
            products: products
        };
    }

    // Show/hide the selected-image thumbnail chip inside the search input.
    // While an image is active, the text input is locked (readOnly + blank value)
    // because the visual endpoint owns the search — text can't be combined with it.
    function setImagePreview(input, imageData) {
        const row = input && input.closest('.convo-input-row');
        if (!row) return;
        const preview = row.querySelector('.convo-image-preview');
        const img = preview && preview.querySelector('img');
        if (preview && img) {
            img.src = imageData;
            preview.classList.add('active');
            row.classList.add('has-preview');
        }

        // Lock typing while an image search is active.
        if (input) {
            input.value = '';
            input.readOnly = true;
            input.setAttribute('aria-readonly', 'true');
            // Remember the placeholder so we can restore it when the image is removed.
            if (input.dataset.convoPrevPlaceholder === undefined) {
                input.dataset.convoPrevPlaceholder = input.getAttribute('placeholder') || '';
            }
            // Use a different placeholder so the user understands what's happening.
            input.setAttribute('placeholder', 'Searching by image — type to switch');
            stopAnimatedPlaceholder();
        }
    }

    function clearImagePreview(input) {
        const row = input && input.closest('.convo-input-row');
        if (!row) return;
        const preview = row.querySelector('.convo-image-preview');
        const fileInput = row.querySelector('.convo-image-input');
        if (preview) {
            preview.classList.remove('active');
            const img = preview.querySelector('img');
            if (img) img.src = '';
        }
        row.classList.remove('has-preview');
        if (fileInput) fileInput.value = '';
        currentImageDataUrl = null;

        // Re-enable typing and restore the original placeholder.
        if (input) {
            input.readOnly = false;
            input.removeAttribute('aria-readonly');
            if (input.dataset.convoPrevPlaceholder !== undefined) {
                input.setAttribute('placeholder', input.dataset.convoPrevPlaceholder);
                delete input.dataset.convoPrevPlaceholder;
            }
        }
    }

    // Handle an uploaded image: send the raw File directly to the visual
    // endpoint. Use a data URL only to render the thumbnail preview chip.
    function handleImageUpload(input, file) {
        if (!file || !file.type || !file.type.startsWith('image/')) {
            return;
        }

        currentInput = input;
        stopAnimatedPlaceholder();

        // Render the thumbnail preview from a data URL (preview only).
        // setImagePreview also locks the input (readOnly + clears value).
        const previewReader = new FileReader();
        previewReader.onload = (e) => {
            // Keep the data URL so "View More" can hand the image to the search page.
            currentImageDataUrl = e.target.result;
            setImagePreview(input, e.target.result);
        };
        previewReader.readAsDataURL(file);

        positionAutocomplete(input);
        openAutocomplete();
        showLoading();

        // Sentinel so a later text search won't render stale image results
        currentQuery = '__convo_image_search__';
        const requestQuery = currentQuery;

        fetchImageAutocomplete(file).then((data) => {
            if (currentQuery === requestQuery) {
                renderResults(data, '');
            }
        });
    }

    function showLoading() {
        const loading = document.getElementById('convo-loading');
        const products = document.getElementById('convo-products');
        const empty = document.getElementById('convo-empty');
        const footer = document.getElementById('convo-footer');

        if (loading) loading.style.display = 'flex';
        if (products) products.style.display = 'none';
        if (empty) empty.style.display = 'none';
        if (footer) footer.style.display = 'none';
    }

    function hideLoading() {
        const loading = document.getElementById('convo-loading');
        if (loading) loading.style.display = 'none';
    }

    function isProductAvailable(product) {
        if (!product.variants || product.variants.length === 0) {
            return false;
        }
        return product.variants.some(variant => variant.available);
    }

    function createSuggestionHTML(suggestion, query) {
        const displayText = suggestion.styled_text || suggestion.text;
        const searchUrl = `${CONVO_CONFIG.searchPageUrl}?q=${encodeURIComponent(suggestion.text)}`;

        return `
            <li class="convo-suggestion-item">
                <a href="${searchUrl}" class="convo-suggestion-link">
                    <svg class="convo-suggestion-icon" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5">
                        <circle cx="9" cy="9" r="6"></circle>
                        <line x1="13.5" y1="13.5" x2="17" y2="17"></line>
                    </svg>
                    <span class="convo-suggestion-text">${displayText}</span>
                </a>
            </li>
        `;
    }

    function renderResults(data, query) {
        hideLoading();

        const suggestionsContainer = document.getElementById('convo-suggestions');
        const suggestionsList = document.getElementById('convo-suggestions-list');
        const productsContainer = document.getElementById('convo-products');
        const productsList = document.getElementById('convo-products-list');
        const emptyContainer = document.getElementById('convo-empty');
        const footer = document.getElementById('convo-footer');

        const suggestions = data.suggestions || [];
        const productsData = data.products;

        if (suggestions.length > 0 && suggestionsList && suggestionsContainer) {
            suggestionsList.innerHTML = suggestions.map(s => createSuggestionHTML(s, query)).join('');
            suggestionsContainer.style.display = 'block';
        } else if (suggestionsContainer) {
            suggestionsContainer.style.display = 'none';
        }

        if (!productsData || !productsData.results || productsData.results.length === 0) {
            if (productsContainer) productsContainer.style.display = 'none';
            if (suggestions.length === 0) {
                if (emptyContainer) emptyContainer.style.display = 'flex';
            } else {
                if (emptyContainer) emptyContainer.style.display = 'none';
            }
            if (footer) footer.style.display = 'none';
            return;
        }

        let availableProducts = productsData.results
            .filter(item => isProductAvailable(item));

        if (query && query.trim() !== '') {
            const queryLower = query.toLowerCase().trim();
            const matchedProducts = availableProducts.filter(p => p.title && p.title.toLowerCase().includes(queryLower));
            const otherProducts = availableProducts.filter(p => !p.title || !p.title.toLowerCase().includes(queryLower));
            availableProducts = [...matchedProducts, ...otherProducts];
        }

        availableProducts = availableProducts.slice(0, CONVO_CONFIG.maxProducts);

        if (availableProducts.length === 0) {
            if (productsContainer) productsContainer.style.display = 'none';
            if (suggestions.length === 0) {
                if (emptyContainer) emptyContainer.style.display = 'flex';
            } else {
                if (emptyContainer) emptyContainer.style.display = 'none';
            }
            if (footer) footer.style.display = 'none';
            return;
        }

        if (productsList && productsContainer) {
            productsList.innerHTML = availableProducts.map(product => createProductCardHTML(product)).join('');
            productsContainer.style.display = 'block';
        }

        if (emptyContainer) emptyContainer.style.display = 'none';
        if (footer) footer.style.display = 'flex';
    }

    function openAutocomplete() {
        const container = document.getElementById('convo-autocomplete');
        if (container) {
            container.style.display = 'block';
            isOpen = true;
        }
    }

    function closeAutocomplete() {
        const container = document.getElementById('convo-autocomplete');
        if (container) {
            container.style.display = 'none';
            isOpen = false;
        }
    }

    function handleInput(event) {
        const input = event.target;

        // If an image search is locked in, ignore any input events.
        // (readOnly should already block typing, but this is a defensive guard.)
        if (input.readOnly) {
            return;
        }

        const query = input.value.trim();
        currentQuery = query;

        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }

        if (query.length === 0) {
            closeAutocomplete();
            if (CONVO_CONFIG.animatedPlaceholder.enabled) {
                startAnimatedPlaceholder(input);
            }
            return;
        }

        stopAnimatedPlaceholder();

        if (query.length < CONVO_CONFIG.minQueryLength) {
            closeAutocomplete();
            return;
        }

        openAutocomplete();
        showLoading();

        debounceTimer = setTimeout(async () => {
            const data = await fetchAutocomplete(query);
            if (currentQuery === query) {
                renderResults(data, query);
            }
        }, CONVO_CONFIG.debounceDelay);
    }

    function handleSubmit(event) {
        const form = event.target;
        const input = form.querySelector('input[name="q"]');

        // Block form submission while an image search is active.
        if (input && input.readOnly) {
            event.preventDefault();
            return;
        }

        if (input && input.value.trim()) {
            event.preventDefault();
            const query = input.value.trim();
            window.location.href = `${CONVO_CONFIG.searchPageUrl}?q=${encodeURIComponent(query)}`;
        }
    }

    // Downscale an image data URL to a JPEG capped at maxDim on its longest
    // side. Used to keep the search-page handoff small enough for sessionStorage.
    function downscaleImage(dataUrl, maxDim, quality) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                let width = img.naturalWidth || img.width;
                let height = img.naturalHeight || img.height;
                if (width > maxDim || height > maxDim) {
                    if (width >= height) {
                        height = Math.round(height * (maxDim / width));
                        width = maxDim;
                    } else {
                        width = Math.round(width * (maxDim / height));
                        height = maxDim;
                    }
                }
                try {
                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    canvas.getContext('2d').drawImage(img, 0, 0, width, height);
                    resolve(canvas.toDataURL('image/jpeg', quality));
                } catch (e) {
                    reject(e);
                }
            };
            img.onerror = reject;
            img.src = dataUrl;
        });
    }


    async function storeImageForSearchPage(dataUrl) {
        const attempts = [
            { maxDim: Infinity, quality: 1 },
            { maxDim: 1280, quality: 0.82 },
            { maxDim: 800, quality: 0.75 },
            { maxDim: 512, quality: 0.7 }
        ];
        for (const opt of attempts) {
            try {
                const payload = opt.maxDim === Infinity
                    ? dataUrl
                    : await downscaleImage(dataUrl, opt.maxDim, opt.quality);
                sessionStorage.setItem('convoImageSearch', payload);
                return true;
            } catch (e) {
                // Quota exceeded or canvas error — retry with a smaller image.
                console.warn('ConvoSearch: image handoff attempt failed, retrying smaller:', e);
            }
        }
        return false;
    }

    function handleViewMoreClick(event) {
        event.preventDefault();
        const isImageSearch = (currentInput && currentInput.readOnly) || currentQuery === '__convo_image_search__';
        if (isImageSearch) {
            if (!currentImageDataUrl) return;
            storeImageForSearchPage(currentImageDataUrl).then((stored) => {
                if (stored) {
                    window.location.href = `${CONVO_CONFIG.searchPageUrl}?image=1`;
                } else {
                    console.error('ConvoSearch: could not hand off image to search page');
                }
            });
            return;
        }
        if (currentQuery && currentQuery !== '__convo_image_search__') {
            window.location.href = `${CONVO_CONFIG.searchPageUrl}?q=${encodeURIComponent(currentQuery)}`;
        }
    }

    function handleClickOutside(event) {
        const container = document.getElementById('convo-autocomplete');
        const searchInputs = document.querySelectorAll('.convo-search-input');

        let clickedInside = false;
        searchInputs.forEach(input => {
            if (input.contains(event.target)) clickedInside = true;
        });

        if (container && !container.contains(event.target) && !clickedInside) {
            closeAutocomplete();
        }
    }

    function positionAutocomplete(input) {
        const container = document.getElementById('convo-autocomplete');
        if (!container || !input) return;

        const inputRect = input.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

        container.style.position = 'fixed';
        container.style.top = `${inputRect.bottom}px`;
        container.style.left = `${inputRect.left}px`;
        container.style.width = `${Math.max(inputRect.width, 400)}px`;
        container.style.maxWidth = '500px';
    }
    function handleReposition() {
        if (isOpen && currentInput) {
            positionAutocomplete(currentInput);
        }
    }

    let currentInput = null;
    const initializedInputs = new WeakSet();

    function initSearchForm(form) {
        const input = form.querySelector('input[name="q"], input[type="search"]');
        if (!input) return;

        if (initializedInputs.has(input)) {
            return;
        }
        initializedInputs.add(input);

        input.classList.add('convo-search-input');

        if (!input.parentElement.classList.contains('convo-input-row')) {
            const wrapper = document.createElement('div');
            wrapper.className = 'convo-input-wrapper';
            input.parentNode.insertBefore(wrapper, input);

            const inputRow = document.createElement('div');
            inputRow.className = 'convo-input-row';
            wrapper.appendChild(inputRow);
            inputRow.appendChild(input);

            const imageSearchHTML = `
                <div class="convo-image-preview">
                    <img alt="Selected image">
                    <button type="button" class="convo-image-preview-remove" aria-label="Remove image">&times;</button>
                </div>
                <button type="button" class="convo-image-search-btn" aria-label="Search by image" title="Search by image">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                        <circle cx="12" cy="13" r="4"></circle>
                    </svg>
                </button>
                <input type="file" class="convo-image-input" accept="image/*" hidden>
            `;
            inputRow.insertAdjacentHTML('beforeend', imageSearchHTML);

            const imageBtn = inputRow.querySelector('.convo-image-search-btn');
            const fileInput = inputRow.querySelector('.convo-image-input');
            const removeBtn = inputRow.querySelector('.convo-image-preview-remove');

            if (imageBtn && fileInput) {
                imageBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    fileInput.click();
                });
                fileInput.addEventListener('change', (e) => {
                    const file = e.target.files && e.target.files[0];
                    if (file) {
                        handleImageUpload(input, file);
                    }
                });
            }

            if (removeBtn) {
                removeBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    clearImagePreview(input);
                    closeAutocomplete();
                    resumeAnimatedPlaceholder(input);
                });
            }

            const poweredByHTML = `<div class="convo-powered-by">
                <a href="https://www.convosearch.com" target="_blank" rel="noopener noreferrer">
                    <span class="convo-powered-by-text">Powered by</span>
                    <img src="${window.Shopify?.routes?.root || '/'}cdn/shop/files/poweredby-conversecart.svg" alt="ConvoSearch" class="convo-powered-by-logo">
                </a>
            </div>`;
            wrapper.insertAdjacentHTML('beforeend', poweredByHTML);
        }

        let existingContainer = document.getElementById('convo-autocomplete');
        if (!existingContainer) {
            document.body.insertAdjacentHTML('beforeend', createAutocompleteHTML());

            const viewMoreBtn = document.querySelector('.convo-view-more-btn');
            if (viewMoreBtn) {
                viewMoreBtn.addEventListener('click', handleViewMoreClick);
            }
        }

        // While an image search is locked in, the input is readOnly. If the user
        // starts typing, drop the image automatically and let the keystroke flow
        // through so it becomes a normal text search.
        input.addEventListener('keydown', (e) => {
            if (!input.readOnly) return;
            // Leave shortcuts and non-character keys (arrows, Tab, F-keys…) alone.
            if (e.ctrlKey || e.metaKey || e.altKey) return;
            if (e.key && e.key.length === 1) {
                clearImagePreview(input);
                // readOnly is now false, so this keystroke types normally and the
                // 'input' handler below picks it up.
            }
        });

        // Same idea for paste: a readOnly input blocks the paste, so drop the
        // image and insert the pasted text manually.
        input.addEventListener('paste', (e) => {
            if (!input.readOnly) return;
            e.preventDefault();
            const text = ((e.clipboardData || window.clipboardData) || { getData: () => '' }).getData('text');
            clearImagePreview(input);
            input.value = text;
            currentInput = input;
            positionAutocomplete(input);
            handleInput({ target: input });
        });

        input.addEventListener('input', (e) => {
            currentInput = input;
            positionAutocomplete(input);
            handleInput(e);
        });

        input.addEventListener('focus', () => {
            currentInput = input;
            // Don't reopen text autocomplete if an image search is active.
            if (input.readOnly) return;
            if (input.value.trim().length >= CONVO_CONFIG.minQueryLength) {
                stopAnimatedPlaceholder();
                positionAutocomplete(input);
                openAutocomplete();
            }
        });

        input.addEventListener('blur', () => {
            setTimeout(() => {
                // Don't restart the typing animation while an image is active.
                if (input.readOnly) return;
                resumeAnimatedPlaceholder(input);
            }, 100);
        });

        if (CONVO_CONFIG.animatedPlaceholder.enabled) {
            startAnimatedPlaceholder(input);
        }

        form.addEventListener('submit', handleSubmit);
    }

    function init() {
        const searchForms = document.querySelectorAll('form[action*="/search"], form[is="predictive-search"]');

        searchForms.forEach(form => {
            if (form.dataset.convoInitialized) return;
            form.dataset.convoInitialized = 'true';
            initSearchForm(form);
        });

        document.addEventListener('click', handleClickOutside);

        window.addEventListener('scroll', handleReposition, true);
        window.addEventListener('resize', handleReposition);

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                closeAutocomplete();
            }
        });
    }

    function addStyles() {
        const styles = `
            .convo-autocomplete-wrapper {
                position: fixed !important;
                max-width: 470px;
                background: rgb(var(--color-background));
                border-top: unset;
                box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
                z-index: 9999;
                overflow: hidden;
                border-radius: 10px 0 0 10px;
            }

            .convo-sugegstions-products-wrapper {
                flex-direction: column;
                width: 100%;
                overflow-y: auto;
                max-height: calc(100vh - 15rem);
                scroll-behavior: smooth;
                scrollbar-width: none;
                padding-bottom: 20px;
            }

            .convo-sugegstions-products-wrapper::-webkit-scrollbar {
                display: none;
            }

            .convo-autocomplete-suggestions {
                width: 100%;
                background: rgb(var(--color-background));
                padding: 10px 15px;
                border-bottom: 1px solid rgb(var(--color-border-light));
            }

            .convo-suggestions-title {
                color: rgb(var(--color-foreground) / 0.5);
                font-weight: 400;
                font-size: 0.75rem;
                margin-bottom: 8px;
                text-transform: uppercase;
                letter-spacing: 0.5px;
            }

            .convo-suggestions-list {
                list-style: none;
                padding: 0;
                margin: 0;
            }

            .convo-suggestion-item {
                margin: 0;
            }

            .convo-suggestion-link {
                display: flex;
                align-items: center;
                gap: 10px;
                padding: 8px 5px;
                text-decoration: none;
                color: rgb(var(--color-foreground));
                border-radius: 4px;
                transition: background 0.15s ease;
            }

            .convo-suggestion-link:hover {
                background: rgb(var(--color-foreground) / 0.05);
            }

            .convo-suggestion-icon {
                width: 16px;
                height: 16px;
                flex-shrink: 0;
                opacity: 0.5;
            }

            .convo-suggestion-text {
                font-size: 0.9rem;
                line-height: 1.3;
            }

            .convo-suggestion-text mark {
                background: transparent;
                color: rgb(var(--color-foreground));
                font-weight: 600;
            }

            .convo-autocomplete-top-products {
                width: 100%;
                background: rgb(var(--color-background));
                padding: 10px 15px 0 15px;
            }

            .convo-top-products-title {
                border-block-end: 1px solid rgb(var(--color-border-light));
                padding-block-end: 0.5rem;
                color: rgb(var(--color-foreground) / 0.5);
                font-weight: 400;
                font-size: 0.75rem;
                text-transform: uppercase;
                letter-spacing: 0.5px;
            }

            .convo-autocomplete-top-products-list {
                list-style: none;
                padding: 0;
                margin: 0;
                display: flex;
                flex-wrap: wrap;
                row-gap: 10px;
            }

            .convo-topproduct-item {
                width: 50%;
                padding: 5px;
                box-sizing: border-box;
            }

            .convo-topproduct-item-link {
                display: flex;
                flex-direction: column;
                text-decoration: none;
                color: inherit;
            }

            .convo-topproduct-image-wrapper {
                position: relative;
                width: 100%;
            }

            .convo-topproduct-item-image {
                width: 100%;
                aspect-ratio: 1;
                overflow: hidden;
                border-radius: var(--card-radius, 10px);
                background: rgb(var(--color-foreground) / 0.05);
            }

            .convo-topproduct-item-image.hover-image {
                display: none;
            }

            .convo-topproduct-item:hover .convo-topproduct-item-image {
                display: none;
            }

            .convo-topproduct-item:hover .convo-topproduct-item-image.hover-image {
                display: block;
            }

            .convo-topproduct-image {
                width: 100%;
                height: 100%;
                object-fit: contain;
                border-radius: var(--card-radius, 10px);
            }

            .convo-topproduct-item-info {
                width: 100%;
                text-align: center;
                padding: 8px 0;
            }

            .convo-topproduct-title {
                color: rgb(var(--color-foreground));
                font-weight: 700;
                font-size: 14px;
                margin: 0 0 5px 0;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                line-height: 1.3;
            }

            .convo-topproduct-price {
                display: flex;
                justify-content: center;
            }

            .convo-topproduct-price .price {
                justify-content: center;
            }

            .convo-topproduct-price .price__sale {
                text-decoration: line-through;
                opacity: 0.5;
            }

            .convo-autocomplete-view-more {
                display: flex;
                justify-content: center;
                padding: 15px 15px 40px 15px;
            }

            .convo-view-more-btn {
                width: 90%;
                background: #1ccb13;
                color: #fff;
                border: none;
                padding: 12px 20px;
                border-radius: 40px;
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
                transition: background 0.2s;
            }

            .convo-view-more-btn:hover {
                background: #0cb771;
            }

            .convo-autocomplete-loading {
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 40px;
            }

            .convo-autocomplete-no-results {
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 40px;
                color: rgb(var(--color-foreground) / 0.5);
            }

            .convo-input-wrapper {
                display: flex;
                flex-direction: column;
                width: 100%;
            }

            .convo-input-wrapper .convo-search-input {
                width: 100%;
            }

            .convo-input-row {
                position: relative;
                display: flex;
                align-items: center;
                width: 100%;
            }

            .convo-input-row .convo-search-input {
                width: 100%;
                padding-right: 42px;
            }

            .convo-input-row.has-preview .convo-search-input {
                padding-left: 78px;
            }

            /* Visual cue that typing is disabled while an image search is active. */
            .convo-input-row.has-preview .convo-search-input,
            .convo-search-input[readonly] {
                cursor: not-allowed;
                background-color: rgb(var(--color-foreground) / 0.04);
            }

            .convo-image-search-btn {
                position: absolute;
                right: 8px;
                top: 50%;
                transform: translateY(-50%);
                display: flex;
                align-items: center;
                justify-content: center;
                width: 30px;
                height: 30px;
                padding: 0;
                background: transparent;
                border: none;
                cursor: pointer;
                color: rgb(var(--color-foreground) / 0.6);
                transition: color 0.15s ease;
                z-index: 2;
            }

            .convo-image-search-btn:hover {
                color: rgb(var(--color-foreground));
            }

            .convo-image-search-btn svg {
                width: 20px;
                height: 20px;
            }

            .convo-image-preview {
                position: absolute;
                left: 8px;
                top: 50%;
                transform: translateY(-50%);
                display: none;
                align-items: center;
                gap: 4px;
                padding: 3px 4px 3px 3px;
                background: rgb(var(--color-foreground) / 0.08);
                border-radius: 6px;
                z-index: 2;
            }

            .convo-image-preview.active {
                display: inline-flex;
            }

            .convo-image-preview img {
                width: 24px;
                height: 24px;
                object-fit: cover;
                border-radius: 4px;
                display: block;
            }

            .convo-image-preview-remove {
                border: none;
                background: transparent;
                cursor: pointer;
                font-size: 16px;
                line-height: 1;
                padding: 0 2px;
                color: rgb(var(--color-foreground) / 0.7);
            }

            .convo-image-preview-remove:hover {
                color: rgb(var(--color-foreground));
            }

            .convo-powered-by {
                display: flex;
                justify-content: flex-end;
                padding: 4px 0 0 0;
                opacity:0.5
            }

            .convo-powered-by a {
                display: inline-flex;
                align-items: center;
                text-decoration: none;
                opacity: 1;
                transition: opacity 0.2s;
            }

            .convo-powered-by a:hover {
                opacity: 1;
            }

            .convo-powered-by-text {
                font-size: 12px;
                margin-right: 4px;
                color: inherit;
            }

            .convo-powered-by-logo {
                height: 10px;
                width: auto;
            }

            .convo-autocomplete-wrapper .convo-spinner {
                width: 24px;
                height: 24px;
                border: 2px solid rgb(var(--color-foreground) / 0.2);
                border-radius: 50%;
                border-top-color: rgb(var(--color-foreground));
                animation: convo-spin 0.8s ease-in-out infinite;
            }

            @keyframes convo-spin {
                to { transform: rotate(360deg); }
            }

            @media (max-width: 768px) {
                .convo-autocomplete-wrapper {
                    position: fixed !important;
                    left: 0 !important;
                    right: 0 !important;
                    max-width: 100%;
                    background: transparent;
                    border: unset;
                    border-radius: 10px 0 0 10px;
                }

                .convo-autocomplete-top-products {
                    background: transparent;
                }

                .convo-autocomplete-top-products-list {
                    margin-top: 10px;
                    gap: 10px;
                    padding: 10px 15px;
                    justify-content: center;
                }

                .convo-topproduct-item {
                    width: 48%;
                    padding-left: unset;
                    padding-right: unset;
                    max-width: 196.8px;
                }

                .convo-topproduct-item-link {
                    color: rgb(var(--color-foreground));
                }

                .convo-topproduct-title {
                    color: rgb(var(--color-foreground)) !important;
                }

                .convo-topproduct-item-image img {
                    border-radius: 10px;
                }

                .convo-topproduct-price {
                    justify-content: center;
                }

                .convo-view-more-btn {
                    background: #1ccb13;
                }
            }
        `;

        const styleSheet = document.createElement('style');
        styleSheet.id = 'convo-autocomplete-styles';
        styleSheet.textContent = styles;
        document.head.appendChild(styleSheet);
    }

    function startConvoSearch() {
        addStyles();
        init();
        setupDrawerListeners();
    }

    function setupDrawerListeners() {
        document.addEventListener('toggle', (e) => {
            if (e.target.matches('details, search-drawer, [data-search-drawer]')) {
                handleDrawerToggle(e.target);
            }
        }, true);

        document.addEventListener('drawer:open', handleDrawerOpen);
        document.addEventListener('shopify:section:load', handleDrawerOpen);

        const drawers = document.querySelectorAll('search-drawer, details[data-search], [data-search-drawer]');
        drawers.forEach(drawer => {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === 'open' || mutation.attributeName === 'aria-hidden') {
                        handleDrawerToggle(drawer);
                    }
                });
            });
            observer.observe(drawer, { attributes: true });
        });

        document.addEventListener('click', (e) => {
            const searchTrigger = e.target.closest('[data-search-toggle], [aria-controls*="search"], .header__icon--search, [href*="search-drawer"]');
            if (searchTrigger) {
                setTimeout(() => {
                    restartAnimationsOnVisibleInputs();
                }, 100);
            }
        });
    }

    function handleDrawerToggle(drawer) {
        const isOpen = drawer.hasAttribute('open') ||
                       drawer.getAttribute('aria-hidden') === 'false' ||
                       drawer.classList.contains('is-open') ||
                       drawer.classList.contains('active');

        if (isOpen) {
            setTimeout(() => {
                restartAnimationsOnVisibleInputs();
            }, 50);
        }
    }

    function handleDrawerOpen() {
        setTimeout(() => {
            restartAnimationsOnVisibleInputs();
        }, 100);
    }

    function restartAnimationsOnVisibleInputs() {
        const inputs = document.querySelectorAll('.convo-search-input');
        inputs.forEach(input => {
            const isVisible = input.offsetParent !== null &&
                             getComputedStyle(input).visibility !== 'hidden' &&
                             getComputedStyle(input).display !== 'none';

            // Don't restart animation if an image search is locked in.
            if (input.readOnly) return;

            if (isVisible && input.value.trim() === '' && CONVO_CONFIG.animatedPlaceholder.enabled) {
                startAnimatedPlaceholder(input);
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', startConvoSearch);
    } else {
        startConvoSearch();
    }

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1) {
                        const wizzyEls = node.querySelectorAll ? node.querySelectorAll('[class*="wizzy-autocomplete"]') : [];
                        wizzyEls.forEach(el => el.remove());

                        const forms = node.querySelectorAll ? node.querySelectorAll('form[action*="/search"]') : [];
                        forms.forEach(form => {
                            if (!form.dataset.convoInitialized) {
                                form.dataset.convoInitialized = 'true';
                                initSearchForm(form);
                            }
                        });

                        const inputs = node.querySelectorAll ? node.querySelectorAll('.convo-search-input') : [];
                        inputs.forEach(input => {
                            if (input.readOnly) return;
                            if (input.value.trim() === '' && CONVO_CONFIG.animatedPlaceholder.enabled) {
                                startAnimatedPlaceholder(input);
                            }
                        });
                    }
                });
            }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    window.ConvoSearchAutocomplete = {
        init: init,
        close: closeAutocomplete,
        config: CONVO_CONFIG,
        startAnimatedPlaceholder: startAnimatedPlaceholder,
        stopAnimatedPlaceholder: stopAnimatedPlaceholder,
        restartAnimations: restartAnimationsOnVisibleInputs
    };

})();